export default process.env.NODE_ENV === 'development'
  ? {
      REACT_APP_NODE_API_URL: 'http://localhost:8080',
    }
  : {
      REACT_APP_NODE_API_URL: '',
    };
